
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import Toast from "react-bootstrap/Toast"
import { statusFalse } from "../../state/apiStatusSlice"

function ApiStatus() {
    const dispatch = useDispatch();
    const {status,operation,message,item} = useSelector(state=>state.apiStatus)

    const isSuccess = (status === "success");
    const isFail = (status === "fail");

    function bgColor() {
        if (isSuccess) {
            return "bg-success"
        } else if (isFail) {
            return "bg-danger"
        }
    }

    function operationPastTense(operation) {
        if (operation.slice(-1) === "e") {
            return `${operation}d`
        } else if(!operation){
            return ''
        }else {
            return `${operation}ed`
        }
    }

    return (
        <>
            {isFail &&
                <Toast
                    style={{ position: 'absolute', top: "2.5rem", right: "2rem", margin: "auto", color: 'white', zIndex:100000
                }}
                    animation={true}
                    autohide={true}
                    delay={5000}
                    onClose={() => dispatch(statusFalse())}
                    show={isFail}
                    className={`${bgColor()} text-center mb-2 mt-2 p-0`}
                    >
                    <Toast.Body className="pt-3 px-3 mt-2">
                        <i
                            onClick={() => dispatch(statusFalse())}
                            className="fas fa-times"
                            style={{
                                color: "white",
                                cursor: "pointer",
                                fontSize: "1rem",
                                position: "absolute",
                                top: 5,
                                right: 5,
                                zIndex:1001
                            }}></i>

                        <strong>
                            <i className="fas fa-exclamation-triangle mr-2"
                            ></i>
                            {
                                Boolean(message) ?
                                message :
                                `${operation} ${item} error, please try again`
                            }
                        </strong>

                    </Toast.Body>
                </Toast>}

            {isSuccess &&
                <Toast
                    style={{
                        position: 'absolute',
                        top: "4.5rem",
                        right: "2rem",
                        margin: "auto",
                        color: 'white',
                        border: "2px solid #28a745",
                        borderRadius: "5px",
                        zIndex:100000
                    }}
                    animation={true}
                    onClose={() => dispatch(statusFalse())}
                    autohide={true}
                    show={isSuccess}
                    delay={3500}
                    className={`${bgColor()} text-center mb-2 p-0`}>

                    <Toast.Body className="py-1 m-1 px-3" >
                        <i className="fas fa-check mr-2" ></i>
                        <strong>
                            {!operation ? 
                                `${item} Successful`
                            :
                                `${item} ${operationPastTense(operation)} successfully`
                            }
                        </strong>
                        <div>{message}</div>
                    </Toast.Body>

                </Toast>}
        </>
    )

}

export default ApiStatus;